export const GET_SUPPLIERS_START = 'GET_SUPPLIERS_START';
export const GET_SUPPLIERS_SUCCESS = 'GET_SUPPLIERS_SUCCESS';
export const GET_SUPPLIERS_ERROR = 'GET_SUPPLIERS_ERROR';
export const GET_SUPPLIERS_END = 'GET_SUPPLIERS_END';
export const CLEAR_SUPPLIERS_STORE = 'CLEAR_SUPPLIERS_STORE';
